var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    viewBox: "0 0 600 225",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.535156 -16.101562 L 4.535156 -10.429688 L 14.964844 0 L 20.40625 0 L 83.898438 -63.265625 L 83.898438 -72.789062 L 20.40625 -136.054688 L 14.964844 -136.054688 L 4.535156 -125.625 L 4.535156 -119.953125 L 56.460938 -68.027344 Z M 4.535156 -16.101562 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.886719 -22.675781 C 37.414062 -22.675781 27.210938 -32.878906 27.210938 -45.351562 L 4.535156 -45.351562 C 5.214844 -19.726562 25.171875 0 49.886719 0 L 117.914062 0 C 143.3125 0 163.265625 -21.316406 163.265625 -45.351562 L 163.265625 -158.730469 L 140.589844 -158.730469 L 140.589844 -45.351562 C 140.589844 -32.878906 130.386719 -22.675781 117.914062 -22.675781 Z M 49.886719 -22.675781 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34.011719 -158.730469 L 11.335938 -158.730469 L 11.335938 0 L 34.011719 0 L 34.011719 -68.027344 L 147.390625 -68.027344 L 147.390625 0 L 170.066406 0 L 170.066406 -158.730469 L 147.390625 -158.730469 L 147.390625 -90.703125 L 34.011719 -90.703125 Z M 34.011719 -158.730469 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyph-0-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 124.714844 -158.730469 L 110.429688 -158.730469 L 0 -17.460938 L 0 0 L 15.191406 0 L 124.714844 -140.363281 Z M 124.714844 -158.730469 "
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%, 0%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 19.661987,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-0",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%, 0%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 108.097387,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-1",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%, 0%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 282.700631,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-2",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(100%, 0%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 464.106597,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-3",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%, 100%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 11.158578,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-0",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%, 100%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 99.593978,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-1",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%, 100%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 274.197223,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-2",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "rgb(0%, 100%, 100%)",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 455.603188,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-3",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 15.410284,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-0",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 103.845684,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-1",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 278.448928,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-2",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    x: 459.854894,
    y: 181.5902,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xlinkHref: "#glyph-0-3",
    xlinkType: "simple",
    xlinkActuate: "onLoad",
    xlinkShow: "embed"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo-text.528b8904.svg";
export { ForwardRef as ReactComponent };